import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
var CustomCountdown = function (_a) {
    var targetDate = _a.targetDate, onComplete = _a.onComplete;
    var _b = useState(targetDate.getTime() - new Date().getTime()), timeLeft = _b[0], setTimeLeft = _b[1];
    useEffect(function () {
        var interval = setInterval(function () {
            var now = new Date().getTime();
            var distance = targetDate.getTime() - now;
            if (distance < 0) {
                clearInterval(interval);
                onComplete();
            }
            else {
                setTimeLeft(distance);
            }
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [targetDate, onComplete]);
    var formatTime = function (time) {
        var minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((time % (1000 * 60)) / 1000);
        return "".concat(minutes, "m ").concat(seconds, "s");
    };
    var toDisplay = formatTime(timeLeft);
    return _jsx("div", { children: toDisplay });
};
export default CustomCountdown;
